import * as Sentry from "@sentry/gatsby";

Sentry.init({
  dsn: process.env.GATSBY_WEB_ENV === "development" ? undefined :  "https://636dce1221a64a1fcc7c23e1b007f07d@o1118694.ingest.us.sentry.io/4509196943491072",
  environment: process.env.GATSBY_WEB_ENV, 
  sendDefaultPii: true,
});
